const prepareTextWithLinks = (str: string) => {
  const urlPattern = /https?:\/\/[^\s]+/g;
  const textWithLinks = str.replace(urlPattern, url => {
    return `<a href="${url}" target="_blank">${url}</a>`;
  });

  return textWithLinks;
};

export default prepareTextWithLinks;
